export class CompanyFinanceInformation {
    /**
     * Passo 5
     */
    equity: number; // Patrimônio líquido
    monthlyRevenue: number; // Faturamento médio mensal dos últimos 12 meses
}